import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-play-circle-icon]',
  template: `
    <svg:path
      d="M8.00033 1.99935C4.68662 1.99935 2.00033 4.68564 2.00033 7.99935C2.00033 11.3131 4.68662 13.9993 8.00033 13.9993C11.314 13.9993 14.0003 11.3131 14.0003 7.99935C14.0003 4.68564 11.314 1.99935 8.00033 1.99935ZM0.666992 7.99935C0.666992 3.94926 3.95024 0.666016 8.00033 0.666016C12.0504 0.666016 15.3337 3.94926 15.3337 7.99935C15.3337 12.0494 12.0504 15.3327 8.00033 15.3327C3.95024 15.3327 0.666992 12.0494 0.666992 7.99935Z" />
    <svg:path
      d="M11.0837 7.95768L6.20866 4.82227V11.0931L11.0837 7.95768ZM5.33366 4.02018L5.34408 3.92643L5.37533 3.8431L5.41699 3.77018L5.46908 3.69727L5.54199 3.6556L5.61491 3.61393L5.69824 3.5931L5.78158 3.58268H5.83366L5.89616 3.60352L5.94824 3.62435L6.01074 3.6556L12.1357 7.5931L12.1774 7.62435L12.2191 7.66602L12.2503 7.70768L12.2816 7.74935L12.3024 7.80143L12.3232 7.85352L12.3337 7.9056V7.95768V8.00977L12.3232 8.06185L12.3024 8.11393L12.2816 8.16602L12.2503 8.20768L12.2191 8.24935L12.1774 8.29102L12.1357 8.32227L6.01074 12.2598L5.94824 12.291L5.89616 12.3118L5.83366 12.3327H5.78158H5.71908L5.66699 12.3223L5.61491 12.3014L5.56283 12.2806L5.51074 12.2493L5.46908 12.2077L5.42741 12.166L5.39616 12.1243L5.37533 12.0723L5.35449 12.0202L5.33366 11.9577V11.8952V4.02018Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayCircleIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
